/**
 * Thumbs Module
 */
window.addEventListener('load', function () {

  // DOM Elements
  const thumbsClick = document.querySelector('.js-thumbs-click');
  if (!thumbsClick)
    return;
  const thumbsResult = document.querySelector('.js-thumbs-result');

  const thumbsApiRoute = thumbsClick.dataset.apiThumbs;
  const postId = thumbsClick.dataset.id;

  if (thumbsClick) {
    thumbsClick.addEventListener('click', async function (ev) {
      ev.preventDefault();
      thumbsClick.disabled = true;
      const heroThumbsResult = document.querySelector('.hero__thumbs-up .result');
      const thumbsStatus = thumbsClick.classList.contains('is-active');

      if (!thumbsStatus) {
        const response = await fetch(`${thumbsApiRoute}${postId}/set`)
        const json = await response.json();
        thumbsResult.textContent = json.thumbs;
        if (heroThumbsResult) {
          heroThumbsResult.textContent = json.thumbs;
        }
        thumbsClick.classList.add('is-active');
        thumbsClick.disabled = false;
      } else {
        const response = await fetch(`${thumbsApiRoute}${postId}/unset`)
        const json = await response.json();
        thumbsResult.textContent = json.thumbs;
        if (heroThumbsResult) {
          heroThumbsResult.textContent = json.thumbs;
        }
        thumbsClick.classList.remove('is-active');
        thumbsClick.disabled = false;
      }
    });
  }
});
